import { TypedUseSelectorHook, useSelector as useUntypedSelector } from 'react-redux';

import { YammerTeamsState } from '../state/types';

export const useSelector: TypedUseSelectorHook<YammerTeamsState> = useUntypedSelector;
